import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getAuthHeaders } from '@/services/AuthClientService';

export const getHeaders = async () => {
  const authHeaders = await getAuthHeaders();

  return {
    'Content-Type': 'application/json',
    ...authHeaders,
  };
};

export const impersonate = async (userId: string): Promise<void> => {
  const headers = await getHeaders();

  const response = await fetch(`${process.env.API_URL}/impersonate`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ userId }),
  });

  const { token } = await response.json();
  if (!token) {
    throw new Error('No token in response');
  }

  const auth = getAuth();
  await signInWithCustomToken(auth, token);
};
